import {Feedback, TaskType} from 'constants/dataEnum';
import {getDeckNumber} from 'contents/ProtocolEditor/VirtualTray/labwareHelper';
import {getSelectedCard} from 'lib/cardAndTaskHelper';
import {parseMessage} from 'lib/stringHelper';
import _ from 'lodash';
import {batch} from 'react-redux';
import {showSnackbar} from 'stores/actions/appStateAction';
import {setTaskIsSelected} from 'stores/actions/cardStateAction';
import {resetSelectedTasks, setSelectedTask} from 'stores/actions/taskListStateAction';
import {hideAspirateDispenseVolumeModal, setFocusedDeckNumber} from 'stores/actions/virtualTrayAction';
import {checkTipVolumeAndShowAspirateDispenseModal} from 'stores/business/aspirateDispenseVolumeModalBusiness';
import {restoreTipCountForSingleCard} from 'stores/business/protocolManagementBusiness';
import {
  checkAndSetSelectedTipChannelByCardId,
  checkAndSetSelectedTipChannelByTask,
  unselectAllTaskInCard,
} from 'stores/business/taskListBusinessAction';
import {editMixingVolumeTask} from 'stores/business/taskListMixingBusiness';
import {globalAddUndoItem} from 'stores/business/undoRedoBusinessAction';

const checkTaskChangesAndDoEditTask = (editedTaskResult, selectedCard, task) => (dispatch) => {
  const {taskType, volume} = editedTaskResult;
  const wasChangesMade = task.mixingVolume !== volume || task.type !== taskType;

  if (wasChangesMade) {
    dispatch(editMixingVolumeTask(task.ID, volume, TaskType.MIXING));
  }

  return wasChangesMade;
};

// eslint-disable-next-line import/prefer-default-export
export const onEditMixingHandler = (task, cardId, onApplyTask) => async (dispatch, getState) => {
  const {cardState} = getState();
  const {cards} = cardState;
  const {labwareID} = task;

  let selectedCard = getSelectedCard(cardState.cards);
  if (selectedCard.length > 1) {
    selectedCard = selectedCard.find((card) => card.ID === cardId);
  } else {
    [selectedCard] = selectedCard;
  }

  const deckNumber = getDeckNumber(labwareID);

  const onEditTaskApplied = (result) => {
    const wasChangesMade = dispatch(checkTaskChangesAndDoEditTask(result, selectedCard, task));

    if (wasChangesMade) {
      const snackbarMsg = parseMessage('protocolEditor.taskList.task.editSuccess');
      dispatch(showSnackbar(Feedback.SUCCESS, snackbarMsg));
    }
    dispatch(restoreTipCountForSingleCard(selectedCard.ID));

    dispatch(unselectAllTaskInCard(selectedCard));
    dispatch(setFocusedDeckNumber(null));
    dispatch(globalAddUndoItem());

    if (!_.isNil(cardId)) {
      dispatch(checkAndSetSelectedTipChannelByCardId(cardId));
    }

    if (onApplyTask) onApplyTask();

    dispatch(hideAspirateDispenseVolumeModal());
  };

  // wait for re-render to get new deckLabwareRefs
  await batch(async () => {
    if (!_.isNil(cardId)) {
      dispatch(checkAndSetSelectedTipChannelByCardId(cardId, true));
    } else {
      dispatch(checkAndSetSelectedTipChannelByTask(task));
    }

    batch(() => {
      dispatch(unselectAllTaskInCard(cards[cardId]));
      dispatch(resetSelectedTasks());

      dispatch(setTaskIsSelected(task.ID, true));
      dispatch(setSelectedTask({taskID: task.ID, taskNumber: task.number, cardID: cardId}));
    });

    dispatch(setFocusedDeckNumber(parseInt(deckNumber, 10)));
  });

  dispatch(checkTipVolumeAndShowAspirateDispenseModal(selectedCard, task, onEditTaskApplied));
};
